import { db } from "../config/firebase";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { api } from "../config/api";

const isPermissionDenied = (error) => {
  const code = error?.code || "";
  const msg = String(error?.message || "");
  return code === "permission-denied" || msg.toLowerCase().includes("insufficient permissions");
};

// Get All Users
export const getRequests = async () => {
    const ref = collection(db, "requests");

    try {
        const res = await getDocs(ref);

        if (res.empty) {
            throw new Error("No requests found");
        }

        const fetchRequests = res.docs.map((e) => ({
            ...e.data(),
            id: e.id,
        }));

        // Sort by year (from prefix) desc, then sequence desc: INYYYY-XXX
        const parseInq = (val) => {
            const m = String(val || '').match(/^IN(\d{4})-(\d{1,})$/i);
            return m ? { year: parseInt(m[1], 10) || 0, seq: parseInt(m[2], 10) || 0 } : { year: 0, seq: 0 };
        };
        const sortedRequests = fetchRequests.sort((a, b) => {
            const A = parseInq(a?.inquireNumber);
            const B = parseInq(b?.inquireNumber);
            if (B.year !== A.year) return B.year - A.year;
            if (B.seq !== A.seq) return B.seq - A.seq;
            // Fallback to creation date if available
            const da = a?.creationDate ? new Date(a.creationDate).getTime() : 0;
            const db = b?.creationDate ? new Date(b.creationDate).getTime() : 0;
            return db - da;
        });

        // console.log('Sorted Requests:', sortedRequests); 
        return sortedRequests;
    } catch (error) {
        // If client Firestore is blocked (rules/App Check), fall back to backend (Admin SDK)
        if (isPermissionDenied(error)) {
            try {
                const proxyRes = await api.get("/firestore/requests");
                const proxyRequests = Array.isArray(proxyRes.data) ? proxyRes.data : [];

                const parseInq = (val) => {
                    const m = String(val || '').match(/^IN(\d{4})-(\d{1,})$/i);
                    return m ? { year: parseInt(m[1], 10) || 0, seq: parseInt(m[2], 10) || 0 } : { year: 0, seq: 0 };
                };
                const sortedRequests = proxyRequests.sort((a, b) => {
                    const A = parseInq(a?.inquireNumber);
                    const B = parseInq(b?.inquireNumber);
                    if (B.year !== A.year) return B.year - A.year;
                    if (B.seq !== A.seq) return B.seq - A.seq;
                    const da = a?.creationDate ? new Date(a.creationDate).getTime() : 0;
                    const db = b?.creationDate ? new Date(b.creationDate).getTime() : 0;
                    return db - da;
                });

                return sortedRequests;
            } catch (proxyError) {
                console.error("Error fetching Requests via proxy:", proxyError);
                throw proxyError;
            }
        }

        console.error("Error fetching Requests:", error);
        throw error;
    }
};



export const getUserRequestById = async (userId) => {
    const ref = collection(db, "requests");

    try {
        const snapshot = await getDocs(ref);
        const userQuotes = [];

        snapshot.forEach((doc) => {
            const quoteData = doc.data();
            if (quoteData.userId === userId) { // Filter quotes by userId
                userQuotes.push({
                    id: doc.id,
                    ...quoteData,
                });
            }
        });

        if (userQuotes.length === 0) {
            throw new Error("No quotes found for the specified user");
        }

        return userQuotes;
    } catch (error) {
        console.error("Error fetching user quotes:", error);
        throw error;
    }
};

export const getQuotesById = async (id) => {
    const ref = collection(db, "quotes", id);

    try {
        const res = await getDocs(ref);

        if (res.empty) {
            throw new Error("No quotes found with the specified role");
        }

        const fetchQuotes = res.docs.map((e) => {
            return {
                ...e.data(),
                id: e.id,
            };
        });

        return fetchQuotes;
    } catch (error) {
        console.error("Error fetching Quotes:", error);
        throw error;
    }
};


export const getQuote = async (id) => {
    const ref = doc(db, "quotes", id);

    try {
        const res = await getDoc(ref);

        if (!res.exists()) {
            throw new Error("Quote not found");
        }

        return { ...res.data(), id };
    } catch (error) {
        console.error("Error fetching Quote:", error);
        throw error;
    }
};
